import { gql } from "@apollo/client";

export default gql`
  query ($id: UUID!) {
    schoolById(id: $id) {
      base_color
      secondary_color
      short_description
    }
  }
`;
